import resellersModule from "../resellersModule.js";

const assetResaleMigrationPaneComponent = {
    templateUrl: "asset-resale-migration-pane",
    bindings: {
        "assetId": "<"
    },
    controller: "assetResaleMigrationPaneController"
};

resellersModule.component("assetResaleMigrationPane", assetResaleMigrationPaneComponent);
export default assetResaleMigrationPaneComponent;